var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"points_list "},[_c('div',{staticClass:"point_content scroll"},_vm._l((_vm.pointList),function(point){return _c('PointRow',{key:point.id,attrs:{"show-add":_vm.canAdd,"point":point}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }